import type { PropsWithChildren } from "react";

import { RegistrationContainer } from "./Container";

import { Steps } from "@/components/wizard/components/Step";
import { useRegistrationStore } from "@/store/registrationStore";
import { i18n } from "@/localization";
import aiviLogo from "@/assets/icons/aivi-logo.svg";

export function RegistrationWizard({ children }: PropsWithChildren) {
	const { step } = useRegistrationStore();

	const stepTitles = [i18n("step1.wizardTitle"), i18n("step2.wizardTitle"), i18n("step3.wizardTitle")];

	// Map your step (1-based) to index (0-based)
	const currentStepIndex = Math.max(0, Math.min(step - 1, stepTitles.length - 1));

	return (
		<RegistrationContainer>
			<div className="grid w-full lg:grid-cols-3">
				<div className="flex items-center justify-between px-6 pt-6 pb-4 lg:hidden">
					<img src={aiviLogo} alt="AIVI" className="h-8" />
					<span className="text-brand-dark/70 text-sm font-medium">
						{i18n("wizard.stepOf", { current: currentStepIndex + 1, total: stepTitles.length })}
					</span>
				</div>
				<div className="hidden shrink-0 p-10 lg:col-span-1 lg:block">
					<img src={aiviLogo} alt="AIVI" className="mb-2 h-8" />
					<Steps
						headerTitle={i18n("wizard.title")}
						current={currentStepIndex}
						items={stepTitles.map((title) => ({ title }))}
					/>
				</div>
				<div className="lg:col-span-2">{children}</div>
			</div>
		</RegistrationContainer>
	);
}
